'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = require('react');
var React__default = _interopDefault(React);
var styledComponents = require('./styled-components.js');
var ValueText = require('./components/ValueText.js');

var NumericalSelectionReporter = function (props) {
    var start = props.start, end = props.end, selected = props.selected;
    var values = [];
    if (start < end) {
        for (var i = start; i <= end; i += 1) {
            values.push(i);
        }
    }
    var startValue = values.shift();
    var endValue = values.pop();
    return (React__default.createElement("div", { style: { display: 'flex' } },
        React__default.createElement(styledComponents.FirstCell, { selected: startValue === selected },
            React__default.createElement(ValueText, { val: startValue || 0, selected: selected })),
        values.map(function (val) { return (React__default.createElement(styledComponents.MiddleCell, { key: val, selected: val === selected },
            React__default.createElement(ValueText, { val: val, selected: selected }))); }),
        React__default.createElement(styledComponents.LastCell, { selected: endValue === selected },
            React__default.createElement(ValueText, { val: endValue || 1, selected: selected }))));
};

module.exports = NumericalSelectionReporter;
